import authApiCreator from 'data_system/token_auth/api';
import { experiencesApi } from './experiencesApi';

const baseAuthPath = '/api/affiliates/auth';
const authApi = authApiCreator(baseAuthPath);

const Api = {
  ...authApi,
  ...experiencesApi,
};

export default Api;
